import { Component } from '@angular/core'
import { LoadingController, IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'

import { UserProvider } from '../../providers/user/user'

import { HousingUnit, User } from '../../models/models'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-housing-unit-user-create',
	templateUrl: 'housing-unit-user-create.html',
})
export class HousingUnitUserCreatePage {
	//public user: User;
	public housingUnit: HousingUnit
	public loading: any
	public is_owner: boolean
	public is_resident: boolean

	/**
	Se true genra un PIN quando crea un nuovo utente
	*/
	public generatePin: boolean = true;

	constructor(
		private loadingCtrl: LoadingController,
		private navCtrl: NavController,
		private navParams: NavParams,
		private toastCtrl: ToastController,
		private users: UserProvider
	) {
		this.housingUnit = navParams.get('housingUnit')
		this.is_owner = navParams.get('is_owner') ? true : false
		this.is_resident = navParams.get('is_resident') ? true : false

		this.generatePin = navParams.get('generatePin') ? true : false
		console.log('housing-unit-user-create page, generatePin: ' + (this.generatePin ? 'true' : 'false'))
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public add(user: User) {
		console.log("[HousingUnitUserCreatePage.add()] Si sta associando l'utente all'unità abitativa:", user, this.housingUnit)

		let self = this
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()

		let roles = []
		if(this.is_owner) {
			roles.push('is_owner')
		}
		if(this.is_resident) {
			roles.push('is_resident')
		}

		this.users.addHousingUnitRoles(user, this.housingUnit, roles).then(housiungUnitUser => {
			let titles = ''
			if(this.is_owner) {
				titles += ' proprietario'
			}
			if(this.is_resident) {
				titles += ' residente'
			}

			let fullname = user.name
			if(user.surname) {
				fullname += ' ' + user.surname
			}

			let type = null
			if(user.type == 'person') {
				type = 'Persona fisica'
			} else if(user.type == 'company') {
				type = 'Persona giuridica'
			} else {
				type = 'Utente di tipo sconosciuto'
			}

			self.loading.dismiss()

			let toast = this.toastCtrl.create({
				message: type + titles + ' "' + fullname + '" associato all\'unità abitativa "' + this.housingUnit.label + " - " + this.housingUnit.internal + '"',
				position: 'middle',
				duration: 3000,
				cssClass: "light"
			})
			toast.present()
			self.navCtrl.pop()
		}).catch((error: any) => {
			console.error("Errore associando l'unità abitativa all'utente", error)
			self.loading.dismiss()
			let toast = this.toastCtrl.create({
				message: 'Errore associando l\'unità abitativa all\'utente',
				position: 'middle',
				duration: 3000,
				cssClass: "danger"
			})
			toast.present()
			self.navCtrl.pop()
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-user-create/housing-unit-user-create.ts